import { FC, useEffect, useState } from 'react';
import { Icon, Tooltip } from 'learning-panel-components';
import { translate } from 'translations';

const GreenCheck: FC<GreenCheckProps> = (props: GreenCheckProps) => {
    const { isOn, isHidden = false, handleOff } = props;
    const [isShown, setIsShown] = useState<boolean>(isOn);
    const INTERVAL_TIME = 5000;
    const justCompleted = translate('JustCompleted');

    useEffect(() => {
        setIsShown(isOn);
    }, [isOn]);

    useEffect(() => {
        if (isShown) {
            const timer = setInterval(() => {
                setIsShown(false);
                handleOff();
            }, INTERVAL_TIME);
            return (): void => clearInterval(timer);
        }
        return undefined;
    }, [isShown]);

    return isShown && !isHidden ? (
        <Tooltip type="secondary" title={justCompleted} placement="top" popperStyle={{ zIndex: 10 }}>
            <span>
                <Icon name="greenCheck" />
            </span>
        </Tooltip>
    ) : (
        <></>
    );
};

interface GreenCheckProps {
    isOn: boolean;
    isHidden?: boolean;
    handleOff: Function;
}

export default GreenCheck;
